import ApiError from '@legacy/js/model/Error';
import axios from 'axios';

export interface DeletionBlocker {
    reason: string
    text: string
    subject: string | null
    url: string | null
}

export interface DeletionItem {
    id: number
    group: 'fee' | 'unlink' | 'delete'
    label: string
    detail: string
}

export interface DeletionPreview {
    childName: string
    token: string
    blockers: DeletionBlocker[]
    items: DeletionItem[]
}

const PREVIEW_TOKEN_HEADER = 'X-Deletion-Preview-Token';

export const DELETION_PREVIEW_OUTDATED = 'conflict.deletionPreviewOutdated';

export async function fetchDeletionPreview(childId: number): Promise<DeletionPreview> {
    try {
        const response = await axios.get<{ data: DeletionPreview }>(`/children/${childId}/deletion-preview`);

        return response.data.data;
    } catch (error: any) {
        throw ApiError.fromResponse(error.response);
    }
}

export async function deleteChild(childId: number, previewToken: string): Promise<void> {
    try {
        await axios.delete(`/children/${childId}`, { headers: { [PREVIEW_TOKEN_HEADER]: previewToken } });
    } catch (error: any) {
        throw ApiError.fromResponse(error.response);
    }
}
